// 🔸 Esta función genera el PDF (sin cambios)
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable'; 



/**
 * Genera un PDF de asistencia a partir de una lista de instancias de `Attendance`.
 * @param {Attendance[]} asistencias - Lista de asistencias ya parseadas.
 */
// Convierte decimal a formato HH:MM
const decimalAHorasMinutos = (decimal) => {
  const horas = Math.floor(decimal);
  const minutos = Math.round((decimal - horas) * 60);
  return `${horas}h ${minutos}m`;
};


export const generarReporteGeneral = (asistencias) => {
  const asistenciasPorUsuario = {};
  asistencias.forEach((a) => {
    if (!asistenciasPorUsuario[a.cedula]) {
      asistenciasPorUsuario[a.cedula] = {
        nombre: a.nombre,
        sucursal: a.sucursal,
        registros: [],
      };
    }
    asistenciasPorUsuario[a.cedula].registros.push(a);
  });

  const doc = new jsPDF();
  let first = true;

  const diasSemana = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sabado'];
  const obtenerDiaSemana = (fecha) => diasSemana[fecha.getUTCDay()];

  Object.entries(asistenciasPorUsuario).forEach(([cedula, data]) => {
    if (!first) doc.addPage();
    first = false;

    // ✅ Agregar el encabezado
    doc.setFontSize(18);
    doc.setFont('helvetica', 'bold');
    doc.text('Autosegurosa', 14, 15);

    doc.setFontSize(16);
    doc.setFont('helvetica', 'normal');
    doc.text(`Empleado: ${data.nombre}`, 14, 25);
    doc.setFontSize(12);
    doc.text(`Cédula: ${cedula}`, 14, 32);
    doc.text(`Sucursal: ${data.sucursal}`, 14, 39);

    const registrosPorFecha = {};

    data.registros.forEach((r) => {
      const fecha = new Date(r.fecha_hora);
      const fechaAjustada = new Date(fecha);
      if (fecha.getUTCHours() < 1) {
        fechaAjustada.setUTCDate(fecha.getUTCDate() - 1);
      }

      const fechaClave = `${fechaAjustada.getUTCFullYear()}-${(fechaAjustada.getUTCMonth() + 1)
        .toString()
        .padStart(2, '0')}-${fechaAjustada.getUTCDate().toString().padStart(2, '0')}`;

      if (!registrosPorFecha[fechaClave]) {
        registrosPorFecha[fechaClave] = [];
      }
      registrosPorFecha[fechaClave].push(r);
    });

    const tableData = [];
    let totalHoras = 0;

    Object.entries(registrosPorFecha).forEach(([fechaClave, registros]) => {
      registros.sort((a, b) => new Date(a.fecha_hora) - new Date(b.fecha_hora));

      for (let i = 0; i < registros.length; i += 2) {
        const entrada = registros[i];
        const salida = registros[i + 1];

        const fecha = new Date(entrada.fecha_hora);
        const diaSemana = obtenerDiaSemana(fecha);
        const fechaStr = `${fecha.getUTCDate().toString().padStart(2, '0')}/${(fecha.getUTCMonth() + 1)
          .toString()
          .padStart(2, '0')}/${fecha.getUTCFullYear()}`;

        const horaEntradaStr = `${fecha.getUTCHours().toString().padStart(2, '0')}:${fecha.getUTCMinutes().toString().padStart(2, '0')}`;

        let horaSalidaStr = '';
        let horasTrabajadas = '';

        if (salida) {
          const horaSalida = new Date(salida.fecha_hora);
          horaSalidaStr = `${horaSalida.getUTCHours().toString().padStart(2, '0')}:${horaSalida.getUTCMinutes().toString().padStart(2, '0')}`;

          const diffMs = horaSalida - fecha;
          const diffHoras = diffMs / (1000 * 60 * 60);
          totalHoras += diffHoras;

          horasTrabajadas = `${diffHoras.toFixed(2)}h (${decimalAHorasMinutos(diffHoras)})`;
        }

        tableData.push([
          diaSemana,
          fechaStr,
          horaEntradaStr,
          horaSalidaStr,
          horasTrabajadas,
        ]);
      }
    });

    autoTable(doc, {
      head: [['Día', 'Fecha', 'Entrada', 'Salida', 'Horas']],
      body: tableData,
      startY: 45,
    });

    const totalHorasTexto = `${totalHoras.toFixed(2)}h (${decimalAHorasMinutos(totalHoras)})`;
    doc.text(`Total de horas trabajadas: ${totalHorasTexto}`, 14, doc.lastAutoTable.finalY + 10);
  });

  doc.save('reporte_asistencia.pdf');
};


